import { createTheme, styled } from "@mui/material/styles";

import PickersDay from "@mui/lab/PickersDay";
import { makeStyles } from "@material-ui/core";

export const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) =>
        prop !== "selectedWeekProps" && prop !== "currentWeekProps",
})(({ selectedWeekProps, currentWeekProps }) => ({
    ...((selectedWeekProps.dayIsBetween || currentWeekProps.dayIsBetween) && {
        backgroundColor: selectedWeekProps.dayIsBetween
            ? globalThis.config.colors.black + "!important"
            : globalThis.config.colors.gray7 + "!important",
        borderRadius: 0,
        color: selectedWeekProps.dayIsBetween
            ? globalThis.config.colors.white + "!important"
            : globalThis.config.colors.black + "!important",
        "&:hover, &:focus": {
            backgroundColor: selectedWeekProps.dayIsBetween
                ? globalThis.config.colors.black
                : globalThis.config.colors.gray7,
        },
        "&.Mui-disabled": {
            color: selectedWeekProps.dayIsBetween
                ? globalThis.config.colors.white
                : globalThis.config.colors.black,
        },
        "& .MuiPickersDay-today": {
            backgroundColor: selectedWeekProps.dayIsBetween
                ? globalThis.config.colors.black
                : globalThis.config.colors.gray7,
            color: selectedWeekProps.dayIsBetween
                ? globalThis.config.colors.white
                : globalThis.config.colors.black,
            border: "0!important",
        },
    }),
    ...((selectedWeekProps.isFirstDay || currentWeekProps.isFirstDay) && {
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
    }),
    ...((selectedWeekProps.isLastDay || currentWeekProps.isLastDay) && {
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%",
    }),
}));

export const DateLabel = styled("h3")({
    fontSize: globalThis.config.fonts.sizes.large,
    fontFamily: globalThis.config.fonts.families.bold,
    marginBottom: 0,
});

export const theme = createTheme({
    palette: {
        primary: {
            main: globalThis.config.colors.black,
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    fontSize: globalThis.config.fonts.sizes.small,
                    fontFamily: globalThis.config.fonts.families.regular,
                    "&:hover": {
                        backgroundColor: globalThis.config.colors.white,
                    },
                    "&.Mui-disabled": {
                        borderRadius: 0,
                        margin: "-2px",
                        width: "3rem",
                        color: globalThis.config.colors.gray4,
                    },
                    "&.Mui-selected": {
                        backgroundColor: globalThis.config.colors.white,
                        color: globalThis.config.colors.black,
                        "&:hover": {
                            backgroundColor: globalThis.config.colors.white,
                        },
                        "&:focus": {
                            backgroundColor: globalThis.config.colors.white,
                        },
                    },
                    "&.MuiPickersDay-dayOutsideMonth": {
                        color: globalThis.config.colors.gray4,
                    },
                    "&:focus": {
                        backgroundColor: globalThis.config.colors.gray8,
                    },
                },
            },
        },
        MuiCalendarPicker: {
            styleOverrides: {
                root: {
                    "& div[role=presentation]": {
                        "& .PrivatePickersFadeTransitionGroup-root": {
                            "& > div": {
                                fontSize: globalThis.config.fonts.sizes.smedium,
                                fontFamily: globalThis.config.fonts.families.medium,
                            },
                        },
                    },
                    "& .PrivatePickersFadeTransitionGroup-root.MuiCalendarPicker-viewTransitionContainer":
                    {
                        "& span.MuiTypography-root": {
                            fontSize: globalThis.config.fonts.sizes.small,
                            fontFamily:
                                globalThis.config.fonts.families.regular,
                            color: globalThis.config.colors.gray3,
                        },
                        height: "19rem",
                    },
                    "& button.PrivatePickersYear-yearButton": {
                        fontSize: globalThis.config.fonts.sizes.small,
                        fontFamily: globalThis.config.fonts.families.regular,
                        border: "0.063rem solid",
                        borderColor: globalThis.config.colors.white,
                        "&:hover": {
                            borderRadius: "3rem",
                            borderColor: globalThis.config.colors.black,
                            backgroundColor: "transparent",
                        },
                        "&.Mui-selected:hover": {
                            backgroundColor: globalThis.config.colors.black,
                        },
                    },
                    "& button.PrivatePickersMonth-root": {
                        fontSize: globalThis.config.fonts.sizes.small,
                        fontFamily: globalThis.config.fonts.families.regular,
                        border: "0.063rem solid",
                        borderColor: globalThis.config.colors.white,
                        "&:hover": {
                            borderRadius: "3rem",
                            borderColor: globalThis.config.colors.black,
                            backgroundColor: "transparent",
                        },
                        "&.Mui-selected:hover": {
                            backgroundColor: globalThis.config.colors.black,
                        },
                    },
                    "& .MuiPickersDay-today": {
                        border: "0!important",
                    },
                    "& div[role='row']": {
                        margin: "0.063rem 1.2rem",
                        padding: "0.063rem",
                        border: "0.063rem solid",
                        borderColor: globalThis.config.colors.white,
                        "&:hover": {
                            borderRadius: "3rem",
                            borderColor: globalThis.config.colors.black,
                        },
                    },
                    "& .MuiButtonBase-root.Mui-selected": {
                        backgroundColor: globalThis.config.colors.white,
                        color: globalThis.config.colors.black,
                        "&:hover": {
                            backgroundColor: globalThis.config.colors.white,
                        },
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    "& .Mui-disabled": {
                        backgroundColor: globalThis.config.colors.gray7,
                    },
                },
                edgeStart: {
                    height: "1.125rem",
                    marginTop: "0.313rem",
                    padding: 0,
                    marginRight: "1.3rem",
                },
                edgeEnd: {
                    height: "1.125rem",
                    marginTop: "0.313rem",
                    padding: 0,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: "-2.15rem",
                    marginTop: "0.5rem",
                    boxShadow: "none",
                    border: "0.063rem solid",
                    borderColor: globalThis.config.colors.gray6,
                    borderRadius: globalThis.config.sizes.borderRadius,
                },
            },
        },
    },
});

export const useStyles = makeStyles(() => ({
    button: {
        cursor: "pointer",
        padding: "0.25rem 0.5rem",
        "& .MuiInputAdornment-positionEnd > button.MuiIconButton-edgeEnd": {
            margin: "0.5rem",
            marginLeft: 0,
            borderRadius: 0,
            "&:hover": {
                borderRadius: 0,
                backgroundColor: "transparent",
            },
        },
        "& .MuiInputAdornment-positionEnd": {
            margin: 0,
        },
        "&:hover": {
            backgroundColor: globalThis.config.colors.gray7,
            borderRadius: "2px",
        },
    },
}));
